import React, {
  FunctionComponent,
  PropsWithChildren,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  Classes,
} from '@blueprintjs/core';

export type Props = {
  isOpen: boolean
  title: string
  onCancelClick: (event?: React.SyntheticEvent<HTMLElement>) => void;
  onSaveClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
};

export const FormDialog: FunctionComponent<Props> = ({
  isOpen,
  title,
  children,
  onCancelClick,
  onSaveClick,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <Dialog
      title={title}
      onClose={onCancelClick}
      isOpen={isOpen}
    >
      <div className={Classes.DIALOG_BODY}>
        {children}
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onCancelClick} intent="none">{t('common.button.cancel')}</Button>
          <Button onClick={onSaveClick} intent="primary" active>{t('common.button.save')}</Button>
        </div>
      </div>
    </Dialog>
  );
};

export default FormDialog;
